import { Warning } from '../../../assets/icons'
import { SVGWrapper } from '../../../components'
import { Section } from '../styles'
import dayjs from 'dayjs'

const CatchUp50To59 = ({ standardLimit, standardCatchup }) => {
  return (
    <Section.ActionItemsMessage warning>
      <SVGWrapper svg={Warning} fill='#3A4D57' size='large' />{' '}
      <Section.ActionItemMessageText>
        You have the chance to save a little more: The IRS permits those aged 50+ in the current
        calendar year to make catch-up contributions to their company’s retirement plan. The
        standard contribution limit in {dayjs().year()} is ${standardLimit?.toLocaleString()} and
        you may contribute up to an additional ${standardCatchup?.maximumAmount?.toLocaleString()}{' '}
        in catch-up contributions for a retirement plan account maximum contribution of $
        {(standardLimit + standardCatchup?.maximumAmount).toLocaleString()}.
      </Section.ActionItemMessageText>
    </Section.ActionItemsMessage>
  )
}
export default CatchUp50To59
